import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {CollectionData} from "../../collection.model";
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {TranslatePipe} from '@ngx-translate/core';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {CdkTextareaAutosize} from "@angular/cdk/text-field";

@Component({
    selector: 'app-collection-new',
    imports: [
        FormsModule,
        MatIcon,
        MatIconButton,
        TranslatePipe,
        MatDialogContent,
        ReactiveFormsModule,
        MatFormField,
        MatInput,
        MatLabel,
        MatButton,
        CdkTextareaAutosize
    ],
    templateUrl: './collection-edit.component.html',
    styleUrl: './collection-edit.component.scss'
})
export class CollectionEditComponent implements OnInit {
    editForm: FormGroup

    constructor(
        private dialogRef: MatDialogRef<CollectionEditComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CollectionData,
        private fb: FormBuilder,
    ) {
        this.editForm = this.fb.group({
            name: [null, [Validators.required, Validators.maxLength(255), Validators.minLength(3)]],
            description: [null, []],
        })
    }
    ngOnInit(): void {
        if (this.data) {
            if (this.data.name) {
                this.editForm.patchValue({
                    name: this.data.name
                })
            }
            if (this.data.description) {
                this.editForm.patchValue({
                    description: this.data.description
                })
            }
        }
    }

    isNew(): boolean {
        return !this.data.uuid
    }

    confirm() {
        this.data.name = this.editForm.value.name;
        this.data.description = this.editForm.value.description;
        this.dialogRef.close(this.data);
    }
    close() {
        this.dialogRef.close(null);
    }
}
